export const insuranceOptions = [
  { label: "AARP", value: "AARP" },
  { label: "Adminsure WC", value: "Adminsure WC" },
  { label: "Adventist Health Care Network", value: "Adventist Health Care Network" },
  { label: "Adventist Health Hanford AHP", value: "Adventist Health Hanford AHP" },
  { label: "Adventist White Memorial - Crown City Medical Group", value: "Adventist White Memorial - Crown City Medical Group" },
  { label: "Aetna", value: "Aetna" },
  { label: "Aetna Administrator Medicare Supplement (Eligibility and Remits Only)", value: "Aetna Administrator Medicare Supplement (Eligibility and Remits Only)" },
  { label: "Aetna Better Health - PA", value: "Aetna Better Health - PA" },
  { label: "Aetna Better Health of California", value: "Aetna Better Health of California" },
  { label: "Aetna Better Health of Florida", value: "Aetna Better Health of Florida" },
  { label: "Aetna Better Health of Illinois Inc", value: "Aetna Better Health of Illinois Inc" },
  { label: "Aetna Better Health of Kansas", value: "Aetna Better Health of Kansas" },
  { label: "Aetna Better Health of Kentucky", value: "Aetna Better Health of Kentucky" },
  { label: "Aetna Better Health of Louisiana", value: "Aetna Better Health of Louisiana" },
  { label: "Aetna Better Health of Maryland", value: "Aetna Better Health of Maryland" },
  { label: "Aetna Better Health of Michigan", value: "Aetna Better Health of Michigan" },
  { label: "Aetna Better Health of New Jersey", value: "Aetna Better Health of New Jersey" },
  { label: "Aetna Better Health of New York", value: "Aetna Better Health of New York" },
  { label: "Aetna Better Health of Ohio", value: "Aetna Better Health of Ohio" },
  { label: "Aetna Better Health of Texas", value: "Aetna Better Health of Texas" },
  { label: "Aetna Better Health of Virginia", value: "Aetna Better Health of Virginia" },
  { label: "Aetna Better Health of West Virginia", value: "Aetna Better Health of West Virginia" },
  { label: "Aetna HDMG", value: "Aetna HDMG" },
  { label: "Aetna Life Insurance Company", value: "Aetna Life Insurance Company" },
  { label: "Aetna Medicare Advantage PFFS", value: "Aetna Medicare Advantage PFFS" },
  { label: "Aetna Medicare Supplement", value: "Aetna Medicare Supplement" },
  { label: "Affinity Health Plan", value: "Affinity Health Plan" },
  { label: "Alignment Health Plan (formerly Citizens Choice HDMG)", value: "Alignment Health Plan (formerly Citizens Choice HDMG)" },
  { label: "Alignment Healthcare", value: "Alignment Healthcare" },
  { label: "Ambetter", value: "Ambetter" },
  { label: "American Specialty Health", value: "American Specialty Health" },
  { label: "Amerigroup", value: "Amerigroup" },
  { label: "AmeriHealth Caritas", value: "AmeriHealth Caritas" },
  { label: "Anthem Blue Cross", value: "Anthem Blue Cross" },
  { label: "Arkansas BlueCross BlueShield", value: "Arkansas BlueCross BlueShield" },
  { label: "Athens Administrators WC", value: "Athens Administrators WC" },
  { label: "Banner Life Insurance", value: "Banner Life Insurance" },
  { label: "Baylor Scott & White Health Plan", value: "Baylor Scott & White Health Plan" },
  { label: "BCBS Arizona", value: "BCBS Arizona" },
  { label: "BCBS Connecticut", value: "BCBS Connecticut" },
  { label: "BCBS Georgia", value: "BCBS Georgia" },
  { label: "BCBS Hawaii - HMSA", value: "BCBS Hawaii - HMSA" },
  { label: "BCBS Illinois", value: "BCBS Illinois" },
  { label: "BCBS Indiana", value: "BCBS Indiana" },
  { label: "BCBS Iowa (Wellmark)", value: "BCBS Iowa (Wellmark)" },
  { label: "BCBS Kentucky", value: "BCBS Kentucky" },
  { label: "BCBS Louisiana", value: "BCBS Louisiana" },
  { label: "BCBS Maryland (CareFirst)", value: "BCBS Maryland (CareFirst)" },
  { label: "BCBS MN Blue Plus Medicaid Waiver", value: "BCBS MN Blue Plus Medicaid Waiver" },
  { label: "BCBS Montana", value: "BCBS Montana" },
  { label: "BCBS Nebraska", value: "BCBS Nebraska" },
  { label: "BCBS Nevada (Anthem)", value: "BCBS Nevada (Anthem)" },
  { label: "BCBS New Jersey", value: "BCBS New Jersey" },
  { label: "BCBS North Carolina", value: "BCBS North Carolina" },
  { label: "BCBS North Dakota", value: "BCBS North Dakota" },
  { label: "BCBS of New York (Excellus)", value: "BCBS of New York (Excellus)" },
  { label: "BCBS Oklahoma", value: "BCBS Oklahoma" },
  { label: "BCBS Oregon (Regence)", value: "BCBS Oregon (Regence)" },
  { label: "BCBS Puerto Rico", value: "BCBS Puerto Rico" },
  { label: "BCBS South Carolina", value: "BCBS South Carolina" },
  { label: "BCBS South Dakota", value: "BCBS South Dakota" },
  { label: "BCBS Texas", value: "BCBS Texas" },
  { label: "BCBS Vermont", value: "BCBS Vermont" },
  { label: "Beacon Health Options", value: "Beacon Health Options" },
  { label: "Blue Cross Blue Shield of Alabama", value: "Blue Cross Blue Shield of Alabama" },
  { label: "Blue Cross Blue Shield of Arizona", value: "Blue Cross Blue Shield of Arizona" },
  { label: "Blue Cross Blue Shield of Kansas City", value: "Blue Cross Blue Shield of Kansas City" },
  { label: "Blue Cross Blue Shield of Louisiana", value: "Blue Cross Blue Shield of Louisiana" },
  { label: "Blue Cross Blue Shield of Massachusetts", value: "Blue Cross Blue Shield of Massachusetts" },
  { label: "Blue Cross Blue Shield of Michigan", value: "Blue Cross Blue Shield of Michigan" },
  { label: "Blue Cross Blue Shield of Minnesota", value: "Blue Cross Blue Shield of Minnesota" },
  { label: "Blue Cross Blue Shield of Mississippi", value: "Blue Cross Blue Shield of Mississippi" },
  { label: "Blue Cross Blue Shield of South Carolina", value: "Blue Cross Blue Shield of South Carolina" },
  { label: "Blue Cross BXMCR", value: "Blue Cross BXMCR" },
  { label: "Blue Cross HDMG", value: "Blue Cross HDMG" },
  { label: "Blue Cross of California", value: "Blue Cross of California" },
  { label: "Blue Cross of Idaho", value: "Blue Cross of Idaho" },
  { label: "Blue Cross of North Carolina", value: "Blue Cross of North Carolina" },
  { label: "Blue Cross Out of State", value: "Blue Cross Out of State" },
  { label: "Blue Shield Federal", value: "Blue Shield Federal" },
  { label: "Blue Shield HDMG", value: "Blue Shield HDMG" },
  { label: "Blue Shield of California", value: "Blue Shield of California" },
  { label: "Blue Shield Out of State", value: "Blue Shield Out of State" },
  { label: "Blue Shield Promise Health Plan", value: "Blue Shield Promise Health Plan" },
  { label: "BlueCross BlueShield of Tennessee", value: "BlueCross BlueShield of Tennessee" },
  { label: "Brand New Day IPA", value: "Brand New Day IPA" },
  { label: "Brand New Day Senior", value: "Brand New Day Senior" },
  { label: "Bright Health", value: "Bright Health" },
  { label: "Capital BlueCross", value: "Capital BlueCross" },
  { label: "CareFirst", value: "CareFirst" },
  { label: "Careington Benefit Solutions (Remits Only)", value: "Careington Benefit Solutions (Remits Only)" },
  { label: "Caremore Health Plan", value: "Caremore Health Plan" },
  { label: "CareOregon", value: "CareOregon" },
  { label: "CareSource", value: "CareSource" },
  { label: "CDPHP", value: "CDPHP" },
  { label: "Centene Corp.", value: "Centene Corp." },
  { label: "Central Health Medicare Plan", value: "Central Health Medicare Plan" },
  { label: "Champus: Tricare West Region", value: "Champus: Tricare West Region" },
  { label: "Champus: Triwest", value: "Champus: Triwest" },
  { label: "Champus: WPS VAPC3", value: "Champus: WPS VAPC3" },
  { label: "ChampVA", value: "ChampVA" },
  { label: "Cigna", value: "Cigna" },
  { label: "Cigna HDMG", value: "Cigna HDMG" },
  { label: "Cigna Healthcare", value: "Cigna Healthcare" },
  { label: "Citizens Choice HDMG (Now Alignment Health Plan)", value: "Citizens Choice HDMG (Now Alignment Health Plan)" },
  { label: "Clover Health", value: "Clover Health" },
  { label: "Community Family Care", value: "Community Family Care" },
  { label: "Community Family Care Medical Group", value: "Community Family Care Medical Group" },
  { label: "Community Health Choice", value: "Community Health Choice" },
  { label: "Dean Health Plan", value: "Dean Health Plan" },
  { label: "DELTA DENTAL OF OKLAHOMA", value: "DELTA DENTAL OF OKLAHOMA" },
  { label: "DDMO", value: "DDMO" },
  { label: "Delta of VA", value: "Delta of VA" },
  { label: "Delta Dental of Missouri", value: "Delta Dental of Missouri" },
  { label: "Devoted Health", value: "Devoted Health" },
  { label: "EBA&M", value: "EBA&M" },
  { label: "El Paso Health", value: "El Paso Health" },
  { label: "EmblemHealth", value: "EmblemHealth" },
  { label: "Excellus Health", value: "Excellus Health" },
  { label: "Fidelis Care", value: "Fidelis Care" },
  { label: "First Health HDMG", value: "First Health HDMG" },
  { label: "First Medical Health Plan", value: "First Medical Health Plan" },
  { label: "Friday Health Plans", value: "Friday Health Plans" },
  { label: "Gateway Health", value: "Gateway Health" },
  { label: "GEHA", value: "GEHA" },
  { label: "Geisinger Gold", value: "Geisinger Gold" },
  { label: "Geisinger Health Plan", value: "Geisinger Health Plan" },
  { label: "Group Health Cooperative of South Central Wisconsin", value: "Group Health Cooperative of South Central Wisconsin" },
  { label: "Guardian Life", value: "Guardian Life" },
  { label: "HAP (Health Alliance Plan of Michigan)", value: "HAP (Health Alliance Plan of Michigan)" },
  { label: "Hawaii Medical Assurance Association (HMAA)", value: "Hawaii Medical Assurance Association (HMAA)" },
  { label: "Hawaii Medical Service Assn.", value: "Hawaii Medical Service Assn." },
  { label: "Health Alliance", value: "Health Alliance" },
  { label: "Health Care LA", value: "Health Care LA" },
  { label: "Health Net HDMG", value: "Health Net HDMG" },
  { label: "Health Net Medi Cal", value: "Health Net Medi Cal" },
  { label: "Healthcare LA", value: "Healthcare LA" },
  { label: "Healthcare La IPA (Lense Management)", value: "Healthcare La IPA (Lense Management)" },
  { label: "HealthFirst", value: "HealthFirst" },
  { label: "HealthPartners", value: "HealthPartners" },
  { label: "Heritage Medical Group- HDMG", value: "Heritage Medical Group- HDMG" },
  { label: "High Desert Medical Group", value: "High Desert Medical Group" },
  { label: "Highmark", value: "Highmark" },
  { label: "Horizon Behavioral Health", value: "Horizon Behavioral Health" },
  { label: "Horizon Blue Cross Blue Shield of New Jersey", value: "Horizon Blue Cross Blue Shield of New Jersey" },
  { label: "Humana", value: "Humana" },
  { label: "Humana HDMG", value: "Humana HDMG" },
  { label: "ICW Group WC", value: "ICW Group WC" },
  { label: "Independence Health Group", value: "Independence Health Group" },
  { label: "Independent Health", value: "Independent Health" },
  { label: "Intercare Holdings Ins Co WC", value: "Intercare Holdings Ins Co WC" },
  { label: "Intercare Holdings Insurance Services", value: "Intercare Holdings Insurance Services" },
  { label: "Intermountain Healthcare", value: "Intermountain Healthcare" },
  { label: "JT 2 Integrated Resources WC", value: "JT 2 Integrated Resources WC" },
  { label: "Kaiser Permanente", value: "Kaiser Permanente" },
  { label: "Kaiser Permanente Northern CA", value: "Kaiser Permanente Northern CA" },
  { label: "Kaiser Permanente Southern CA", value: "Kaiser Permanente Southern CA" },
  { label: "Kaiser Senior", value: "Kaiser Senior" },
  { label: "Kern Family Healthcare Medi", value: "Kern Family Healthcare Medi" },
  { label: "LA Care Direct", value: "LA Care Direct" },
  { label: "LA Care HDMG", value: "LA Care HDMG" },
  { label: "LA Care Health Plan", value: "LA Care Health Plan" },
  { label: "Lincoln Financial Group", value: "Lincoln Financial Group" },
  { label: "Martin's Point Generations Advantage", value: "Martin's Point Generations Advantage" },
  { label: "MassMutual", value: "MassMutual" },
  { label: "Medi Cal California", value: "Medi Cal California" },
  { label: "Medica", value: "Medica" },
  { label: "Medi-Cal", value: "Medi-Cal" },
  { label: "Medical Mutual of North Carolina", value: "Medical Mutual of North Carolina" },
  { label: "Medical Mutual of Ohio", value: "Medical Mutual of Ohio" },
  { label: "Medicare (Jurisdiction E) Noridian", value: "Medicare (Jurisdiction E) Noridian" },
  { label: "Medicare Palmetto GBA (Jurisdiction 1)", value: "Medicare Palmetto GBA (Jurisdiction 1)" },
  { label: "Medicare Railroad-Palmetto GBA", value: "Medicare Railroad-Palmetto GBA" },
  { label: "MediGold", value: "MediGold" },
  { label: "Meritain Health Minneapolis", value: "Meritain Health Minneapolis" },
  { label: "Moda Health", value: "Moda Health" },
  { label: "Molina Complete Care of Arizona", value: "Molina Complete Care of Arizona" },
  { label: "Molina HDMG", value: "Molina HDMG" },
  { label: "Molina Healthcare", value: "Molina Healthcare" },
  { label: "Molina Healthcare of Florida", value: "Molina Healthcare of Florida" },
  { label: "Molina Healthcare of Washington", value: "Molina Healthcare of Washington" },
  { label: "Molina Healthcare of Wisconsin", value: "Molina Healthcare of Wisconsin" },
  { label: "Mutual of Omaha", value: "Mutual of Omaha" },
  { label: "MVP Health Care", value: "MVP Health Care" },
  { label: "National Association Of Letter Carriers (NALC)", value: "National Association Of Letter Carriers (NALC)" },
  { label: "Neighborhood Health Plan of Rhode Island", value: "Neighborhood Health Plan of Rhode Island" },
  { label: "New York Life", value: "New York Life" },
  { label: "New York Life Group Benefit Solutions", value: "New York Life Group Benefit Solutions" },
  { label: "Northwestern Mutual", value: "Northwestern Mutual" },
  { label: "Optum Medical Group", value: "Optum Medical Group" },
  { label: "Oscar Health", value: "Oscar Health" },
  { label: "Oscar Insurance", value: "Oscar Insurance" },
  { label: "Pacific Life", value: "Pacific Life" },
  { label: "Pacificare HDMG", value: "Pacificare HDMG" },
  { label: "PacificSource", value: "PacificSource" },
  { label: "Peach State Health Plan", value: "Peach State Health Plan" },
  { label: "Pennsylvania of Human Services", value: "Pennsylvania of Human Services" },
  { label: "Premera BCBS", value: "Premera BCBS" },
  { label: "Premera Blue Cross", value: "Premera Blue Cross" },
  { label: "Premier Admin Solutions (Remits Only)", value: "Premier Admin Solutions (Remits Only)" },
  { label: "Premier Care IPA (ProCare MSO)", value: "Premier Care IPA (ProCare MSO)" },
  { label: "Priority Health", value: "Priority Health" },
  { label: "Priority Partners", value: "Priority Partners" },
  { label: "Prominence Health Plan", value: "Prominence Health Plan" },
  { label: "Prospect Medical Group", value: "Prospect Medical Group" },
  { label: "Providence St. Joseph Health", value: "Providence St. Joseph Health" },
  { label: "Prudential Financial", value: "Prudential Financial" },
  { label: "Quantum Health", value: "Quantum Health" },
  { label: "Quartz Health Solution", value: "Quartz Health Solution" },
  { label: "Regence", value: "Regence" },
  { label: "Sanford Health Plan", value: "Sanford Health Plan" },
  { label: "Scan HDMG", value: "Scan HDMG" },
  { label: "Scan Health Care", value: "Scan Health Care" },
  { label: "Scan Health Plan", value: "Scan Health Plan" },
  { label: "Secure Horizon HDMG (Part of UHC)", value: "Secure Horizon HDMG (Part of UHC)" },
  { label: "Security Benefit Group", value: "Security Benefit Group" },
  { label: "Security Health Plan", value: "Security Health Plan" },
  { label: "Sedgwick WC", value: "Sedgwick WC" },
  { label: "SelectHealth", value: "SelectHealth" },
  { label: "Sendero Health Plans", value: "Sendero Health Plans" },
  { label: "Sierra Medical Group", value: "Sierra Medical Group" },
  { label: "Tricare Prime", value: "Tricare Prime" },
  { label: "Tricare West Region", value: "Tricare West Region" },
  { label: "TriWest VA CCN Claims", value: "TriWest VA CCN Claims" },
  { label: "Tufts Health", value: "Tufts Health" },
  { label: "Tufts Health Together", value: "Tufts Health Together" },
  { label: "UHC", value: "UHC" },
  { label: "UHC Medicare Advantage", value: "UHC Medicare Advantage" },
  { label: "UMR", value: "UMR" },
  { label: "United", value: "United" },
  { label: "United Healthcare", value: "United Healthcare" },
  { label: "United Healthcare HDMG", value: "United Healthcare HDMG" },
  { label: "United Healthcare Medicare Advantage", value: "United Healthcare Medicare Advantage" },
  { label: "United Healthcare Shared Services", value: "United Healthcare Shared Services" },
  { label: "UnitedHealth Group", value: "UnitedHealth Group" },
  { label: "UPMC for You", value: "UPMC for You" },
  { label: "UPMC Health Plan", value: "UPMC Health Plan" },
  { label: "Veterans Admin VA Fee Basis Programs", value: "Veterans Admin VA Fee Basis Programs" },
  { label: "Veterans Evaluation Services", value: "Veterans Evaluation Services" },
  { label: "VHA Office of Community Care", value: "VHA Office of Community Care" },
  { label: "WellCare High Desert MG", value: "WellCare High Desert MG" },
  { label: "Wellcare TexanPlus", value: "Wellcare TexanPlus" },
  { label: "WellSense Health Plan", value: "WellSense Health Plan" }
];

export const networkPlanTypes = [
  { label: "HMO", value: "hmo" },
  { label: "PPO", value: "ppo" },
  { label: "EPO", value: "epo" },
];

// Place of Service options (selected codes only)
export const placeOfServiceOptions = [
  { value: 'Telehealth Provided Other than in Patient\'s Home', label: 'Telehealth Provided Other than in Patient\'s Home' },
  { value: 'Telehealth Provided in Patient\'s Home', label: 'Telehealth Provided in Patient\'s Home' },
  { value: 'Office', label: 'Office' },
  { value: 'Home', label: 'Home' },
  { value: 'Off Campus-Outpatient Hospital', label: 'Off Campus-Outpatient Hospital' },
  { value: 'Urgent Care Facility', label: 'Urgent Care Facility' },
  { value: 'Inpatient Hospital', label: 'Inpatient Hospital' },
  { value: 'On Campus-Outpatient Hospital', label: 'On Campus-Outpatient Hospital' }
]; 